import { defineStore } from 'pinia';

import { MANUSCRIPT_V1_API_URL_PREFIX as URL_PREFIX } from '@/lib/constants/manuscripts/api';
import * as action from '@/lib/constants/manuscripts/store';

const useManuscriptUserStore = defineStore(
  'manuscript-users',

  {
    state: () => ({
      users: [],
      isLoading: false,
    }),

    getters: {
      // TODO: WIP
    },

    actions: {
      async [action.GET_USERS]() {
        // Check cache first
        if (this.users && this.users.length > 0) {
          window.console.log('📋 Users: Using cached data');
          return this.users;
        }

        this.isLoading = true;

        try {
          const response = await this.appApi(`${URL_PREFIX}/users/`);
          console.log('RESPONSE', response);
          this.users = response?.data?.users || [];
          window.console.log('📋 Users: Fetched', this.users.length, 'users');
          return this.users;
        } catch (error) {
          window.console.error('🏪 Users Store: API call failed', error);
          return [];
        } finally {
          this.isLoading = false;
        }
      },
    },
  },
);

export default useManuscriptUserStore;
